var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-tabbar',{attrs:{"route":""}},[_c('van-tabbar-item',{attrs:{"replace":"","to":"/","icon":"home-o"}},[_vm._v("首页")]),_vm._v(" "),_c('van-tabbar-item',{attrs:{"replace":"","to":"/index1","icon":"description"}},[_vm._v("话术库")]),_vm._v(" "),_c('van-tabbar-item',{attrs:{"replace":"","to":"/index2","icon":"orders-o"}},[_vm._v("知识库")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33829de2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tab.vue
// module id = null
// module chunks = 